import { ComponentType, lazy } from 'react'

export const lazyWithRetry = <T extends ComponentType<any>>(
  factory: () => Promise<{ default: T }>,
) => {
  return lazy(async () => {
    try {
      return await factory()
    } catch (error: any) {
      // 청크 로드 에러인지 확인 (메시지는 브라우저/번들러마다 다를 수 있어 포괄적으로 체크)
      const isChunkError =
        error.message.includes('error loading dynamically imported module') ||
        error.message.includes('Importing a module script failed') ||
        error.name === 'ChunkLoadError'

      if (isChunkError) {
        // 무한 새로고침 방지를 위해 sessionStorage 체크
        const storageKey = `retry-lazy-${window.location.hash}`
        const hasRetried = sessionStorage.getItem(storageKey)

        if (!hasRetried) {
          sessionStorage.setItem(storageKey, 'true')
          window.location.reload() // 페이지를 새로고침하여 최신 index.html을 받아옴
        }
      }
      throw error // 재시도 후에도 에러라면 ErrorBoundary로 넘김
    }
  })
}
